/* src/app/shared/components/header/header.component.scss */
.flex-center {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.fill-height,
.white-content-page,
.white-sheet-content {
  flex: 1 0 auto;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  align-content: stretch;
}
.page-center,
.header,
.white-content-page .ups-content-block,
.white-content-page .ups-page-header,
.white-sheet-content {
  min-width: 21.5rem;
  max-width: 71.875rem;
  width: 100%;
  margin: 0 auto;
}
.white-sheet-content {
  background-color: white;
}
.white-sheet-content .ups-page-header {
  padding: 1.125rem 23px;
}
@media screen and (min-width: 48rem) {
  .white-sheet-content .ups-page-header {
    padding: 2.625rem 2rem;
  }
}
.white-content-page {
  background-color: white;
  min-height: 100%;
}
.white-content-page .ups-page-header {
  padding-bottom: 1em;
  min-width: auto;
}
.white-content-page .ups-content-block {
  padding: 0 2rem 2em;
}
.header {
  min-width: 27em;
  font-size: 1em;
  padding: 0.5em 0;
}
@media screen and (min-width: 48rem) {
  .header {
    padding: 0.5em 2em;
  }
}
.header .header-items {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  margin: 0 auto;
  min-width: 21.5rem;
  max-width: 75rem;
}
@media screen and (min-width: 48rem) {
  .header .header-items {
    flex-direction: row;
    align-items: center;
  }
}
.header .header-items .header-item {
  display: flex;
  flex-direction: row;
  align-items: stretch;
  justify-content: flex-end;
  column-gap: 0.5rem;
}
.header .header-items .header-item.logo-container {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  height: 3.75em;
}
@media screen and (min-width: 48rem) {
  .header .header-items .header-item.logo-container {
    max-width: 20%;
  }
}
.header .header-items .header-item.logo-container .side-nav-toggle {
  margin-right: 1em;
  color: #242424;
  display: flex;
}
.header .header-items .header-item.logo-container .side-nav-toggle:hover {
  color: #004791;
}
@media screen and (min-width: 48rem) {
  .header .header-items .header-item.logo-container .side-nav-toggle {
    display: none;
  }
}
.header .header-items .header-item.logo-container upsc-logo {
  padding-left: 3em;
}
@media screen and (min-width: 48rem) {
  .header .header-items .header-item.logo-container upsc-logo {
    padding-left: 0;
  }
}
.header .header-items .header-item.last-item {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  font-size: 0.75em;
  height: 3.0625em;
  background-color: #f5f5f5;
  margin-left: -1rem;
  padding: 0 0.9375rem;
}
@media screen and (min-width: 48rem) {
  .header .header-items .header-item.last-item {
    margin-left: auto;
    flex-direction: row;
    align-items: center;
    font-size: 0.9375em;
    padding-left: 0;
  }
}
@media screen and (min-width: 48rem) {
  .header .header-items .header-item.last-item upsc-user-block,
  .header .header-items .header-item.last-item upsc-language-selector {
    margin-top: 0;
  }
}
@media screen and (min-width: 48rem) {
  .header .header-items .header-item.last-item upsc-user-block {
    margin-left: 0;
  }
}
.header .header-items .header-item.last-item upsc-language-selector {
  margin-left: auto;
}
:host-context(.no-sidebar) .header-item.logo-container .side-nav-toggle {
  display: none !important;
}
@media only screen and (max-width: 21.5rem) {
  :host-context(.no-sidebar) .header-item.logo-container upsc-logo {
    padding-left: 7em !important;
  }
}
/*# sourceMappingURL=header.component.css.map */
